import React, { useState, useEffect, useRef, useContext } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FiSearch } from 'react-icons/fi';
import { IoClose } from 'react-icons/io5';

import { GlobalContext } from '../../context/GlobalContext';
import IconsSubmit from '../../components/styled/IconsSubmit';

const Archieve = ({
    setData,
    text,
    setText,
    setImages,
    setViewText,
}) => {
    const { API_URL } = useContext(GlobalContext);

    const [isLoading, setIsLoading] = useState(false);
    const [showSettings, setShowSettings] = useState(false);

    const storedData = JSON.parse(localStorage.getItem('avatarUser'));
    const authTokenAccess = storedData?.access_token || null;

    const textAreaRef = useRef(null);

    useEffect(() => {
        if (textAreaRef.current) {
            textAreaRef.current.style.height = 'auto';
            textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
        }
    }, [text]);

    // ========================
    // Search Settings
    // ========================
    // const [srclang, setSrclang] = useState('en');
    // const [tgtlang, setTgtlang] = useState('hi');
    const [searchType, setSearchType] = useState('semantic');
    const [k, setK] = useState(5);

    // ========================
    // Search API
    // ========================
    const handleSearch = async (e) => {
        if (e) e.preventDefault();

        if (!text?.trim()) {
            toast.warning('Please enter text to search.');
            return;
        }

        setData([]);
        setImages([]);
        setViewText('');

        const payload = {
            query: text,
            token: authTokenAccess,
            // srclang,
            // tgtlang,
            search_type: searchType,
            k: Number(k),
        };

        try {
            setIsLoading(true);

            const response = await axios.post(`${API_URL}/api/search`, payload, {
                    headers: {'Content-Type': 'application/json' },
                }
            );

            if (response.status === 200) {
                let result = [];
            
                if (searchType === "semantic") {
                    const semanticResults = response.data?.data?.results || [];
            
                    result = semanticResults.map(item => ({
                        ...item.metadata,
                        score: item.score
                    }));
                } else {
                    result = response.data?.data || [];
                }
            
                if (result.length === 0) {
                    toast.error("No results found.");
                } else {
                    setData(result);
                    toast.success(`Found ${result.length} results`);
                }
            
                setShowSettings(false);
            }
        } catch (error) {
            console.error(error);

            toast.error(
                error?.response?.data?.message ||
                error.message ||
                'Search failed'
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {/* Search Button */}
            <div className="flex justify-start">
                <button
                    onClick={() => setShowSettings(true)}
                    className="flex items-center gap-2 text-xl px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition"
                >
                    <FiSearch size={28} />
                    Search
                </button>
            </div>

            {/* Modal */}
            {showSettings && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 h-screen overflow-y-auto">
                    <div className="w-full max-w-2xl rounded-xl bg-white shadow-xl">
                        {/* Header */}
                        <div className="flex items-center justify-between border-b px-6 py-4">
                            <h2 className="text-xl font-semibold">
                                Semantic Search
                            </h2>

                            <button
                                onClick={() => setShowSettings(false)}
                                className="rounded p-1 hover:bg-gray-100"
                            >
                                <IoClose size={24} />
                            </button>
                        </div>

                        {/* Form */}
                        <form
                            onSubmit={handleSearch}
                            className="space-y-5 p-6"
                        >
                            {/* Query */}
                            <div>
                                <label className="mb-2 text-left block text-md font-medium text-gray-700">
                                    Search Query
                                </label>

                                <textarea
                                    ref={textAreaRef}
                                    rows={5}
                                    value={text}
                                    onChange={(e) =>
                                        setText(e.target.value)
                                    }
                                    placeholder="Enter search text..."
                                    className="w-full rounded-lg border border-gray-300 p-3 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            {/* Languages */}
                            {/* <div className="grid grid-cols-1 gap-4 md:grid-cols-2 text-left">
                                <div>
                                    <label className="mb-2 block text-sm font-medium text-gray-700">
                                        Source Language
                                    </label>

                                    <select
                                        value={srclang}
                                        onChange={(e) =>
                                            setSrclang(e.target.value)
                                        }
                                        className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option value="en">English</option>
                                        <option value="bn">Bengali</option>
                                        <option value="hi">Hindi</option>
                                        <option value="ur">Urdu</option>
                                        <option value="gu">Gujarati</option>
                                        <option value="ne">Nepali</option>
                                    </select>
                                </div>

                                <div>
                                    <label className="mb-2 text-left block text-sm font-medium text-gray-700">
                                        Target Language
                                    </label>

                                    <select
                                        value={tgtlang}
                                        onChange={(e) =>
                                            setTgtlang(e.target.value)
                                        }
                                        className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option value="bn">Bengali</option>
                                        <option value="en">English</option>
                                        <option value="hi">Hindi</option>
                                        <option value="ur">Urdu</option>
                                        <option value="gu">Gujarati</option>
                                        <option value="ne">Nepali</option>
                                    </select>
                                </div>
                            </div> */}

                            {/* Search Type */}
                            <div>
                                <label className="mb-2 text-left block text-sm font-medium text-gray-700">
                                    Search Type
                                </label>

                                <div className="flex gap-6">
                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            value="semantic"
                                            checked={
                                                searchType === 'semantic'
                                            }
                                            onChange={(e) =>
                                                setSearchType(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        Semantic
                                    </label>

                                    <label className="flex items-center gap-2">
                                        <input
                                            type="radio"
                                            value="keyword"
                                            checked={
                                                searchType === 'keyword'
                                            }
                                            onChange={(e) =>
                                                setSearchType(
                                                    e.target.value
                                                )
                                            }
                                        />
                                        Keyword
                                    </label>
                                </div>
                            </div>

                            {/* K Value */}
                            <div>
                                <label className="block text-left text-sm font-medium text-gray-700 mb-2">
                                    Top K
                                </label>

                                <select
                                    value={k}
                                    onChange={(e) => setK(Number(e.target.value))}
                                    className="w-full rounded-lg border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                >
                                    {[2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => (
                                        <option key={num} value={num}>
                                            {num}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Footer */}
                            <div className="flex justify-end gap-3 border-t pt-4">
                                <button
                                    type="button"
                                    onClick={() =>
                                        setShowSettings(false)
                                    }
                                    className="rounded-lg border px-4 py-2 hover:bg-gray-100"
                                >
                                    Cancel
                                </button>

                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="flex min-w-[120px] items-center justify-center gap-2 rounded-lg bg-blue-600 px-2 py-2 text-white hover:bg-blue-700 disabled:opacity-60"
                                >
                                    {isLoading ? (
                                        <IconsSubmit />
                                    ) : (
                                        <>
                                            Submit
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
};

export default Archieve;